export const services = [
  {
    id: 1,
    title: 'Exterior Detail',
    prices: [
      { type: 'Hatchback', price: 110 },
      { type: 'Saloon, Small SUV', price: 130 },
      { type: 'Large SUV/Truck', price: 150 }
    ],
    description: 'Hand wash, clean windows, tyres and rims, tyre shine, clay treatment, slick mist speed wax',
    addOns: [
      { name: 'Add Vacuum', price: 23 },
      { name: 'Add Engine Compartment', price: 32 }
    ]
  },
  {
    id: 2,
    title: 'Interior Detail',
    prices: [
      { type: 'Hatchback', price: 138 },
      { type: 'Saloon, Small SUV', price: 161 },
      { type: 'Large SUV/Truck', price: 184 }
    ],
    description: 'Vacuum, condition and shampoo interior including rugs and mats, clean windows and door jambs'
  },
  {
    id: 3,
    title: 'Paint Correction OR Chrome & Aluminium Polishing',
    price: 51,
    priceType: 'per hr',
    description: 'Professional paint correction to restore shine and remove imperfections'
  },
  {
    id: 4,
    title: 'Complete Interior & Exterior',
    prices: [
      { type: 'Hatchback', price: 230 },
      { type: 'Saloon, Small SUV', price: 276 },
      { type: 'Large SUV/Truck', price: 322 }
    ],
    description: 'Hand wash, clean windows, tyres and rims, clay treatment, slick mist speed wax. Vacuum, condition and shampoo interior including rugs and mats, clean door jambs and engine compartment.'
  },
  {
    id: 5,
    title: 'Excessive pet hair removal',
    price: 46,
    priceType: 'per hr'
  },
  {
    id: 6,
    title: 'Nicotine removal',
    price: 46,
    priceType: 'per hr'
  }
];

export const motorcycleServices = [
  {
    id: 1,
    title: 'Motorcycles',
    prices: [
      { type: 'Small Bike', price: 184 },
      { type: 'Bagger', price: 230 }
    ],
    details: [
      'Chrome or aluminium polishing - €46 Per hr plus materials',
      'Paint correction, multi stages of buffing - €46 per hr Plus material'
    ]
  },
  {
    id: 2,
    title: 'Ceramic Coating',
    prices: [
      { type: 'Small bikes', price: 92 },
      { type: 'Bagger', price: 138 }
    ]
  }
];

export const ceramicCoatingPrices = [
  { doors: 2, price: 551 },
  { doors: 4, price: 643 },
  { type: 'Regular SUV / Small Truck', price: 827 },
  { type: 'Mid-sized SUV / Mid-sized truck', price: 919 },
  { type: 'Larger vehicles and RVs', note: 'Priced per item' }
];

export const additionalInfo = [
  'The above pricing includes 1 stage of paint corrections. Each vehicle will be inspected prior and it will be determined if 1 stage of paint correction is enough. If not enough - a price will be supplied for additional paint correction',
  'Courtesy collection within 15km'
];

export const testimonials = [
  {
    id: 1,
    name: 'Sean M.',
    text: 'Kingdom Auto Detailing did an amazing job on my car! It looks better than new. I highly recommend their services.'
  },
  {
    id: 2,
    name: 'Aoife K.',
    text: 'I was blown away by the level of detail and care that Kingdom Auto Detailing put into my ceramic coating. My car is protected and looks fantastic!'
  },
  {
    id: 3,
    name: 'Liam O.',
    text: 'The paint correction service completely transformed my car. The swirl marks are gone, and the paint is incredibly glossy. Thank you, Kingdom Auto Detailing!'
  }
];

export const aboutContent = {
  title: 'About Kingdom Auto Detailing',
  description: 'Kingdom Auto Detailing is a locally owned and operated business serving Tralee and Co Kerry. We are passionate about providing the highest quality automotive detailing services to our community. Our commitment to excellence and customer satisfaction sets us apart.',
  commitment: {
    title: 'Committed to perfection',
    text: 'At Kingdom Auto Detailing, we believe that every vehicle deserves the best possible care. That\'s why we go above and beyond to deliver exceptional results that exceed your expectations. We are committed to providing a professional and reliable service that you can trust.'
  }
};

export const contactInfo = {
  phone: '089 653 6680',
  email: 'kingdomadbooking@gmail.com',
  address: 'Co Kerry',
  city: 'Ireland',
  state: ''
};